export default {
  existProfessonal: {
    type: String,
    default: false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/form/components/invite/resources/props.js